import { theme, useMediaQuery } from 'academy-common-lib/utils/Styling';
import HorizontalLayoutContainer from '../publicLayout/components/HorizontalLayoutContainer';
import { H2, H4 } from 'UIComponents/elements/headings';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import FormattedMessage from 'I18n/components/FormattedMessage';
import StyledSection from '../publicLayout/components/StyledSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Icon = ({
  name
}) => /*#__PURE__*/_jsx("div", {
  className: "m-bottom-3",
  style: {
    color: theme.colors.EERIE
  },
  children: /*#__PURE__*/_jsx(UIIcon, {
    name: name,
    size: 50
  })
});
const columnWidth = 350;
const WhyGetCertifiedSection = () => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(StyledSection, {
    backgroundColor: theme.colors.GYPSUM,
    className: "text-center",
    children: /*#__PURE__*/_jsxs(HorizontalLayoutContainer, {
      children: [/*#__PURE__*/_jsx(H2, {
        className: "m-bottom-15",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.whyGetCertifiedSection.title"
        })
      }), /*#__PURE__*/_jsxs(UIFlex, {
        gap: 30,
        justify: "around",
        wrap: isMobile ? 'wrap' : 'nowrap',
        children: [/*#__PURE__*/_jsxs(UIBox, {
          basis: columnWidth,
          children: [/*#__PURE__*/_jsx(Icon, {
            name: "cap"
          }), /*#__PURE__*/_jsx(H4, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.whyGetCertifiedSection.getEducated"
            })
          }), /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.whyGetCertifiedSection.getEducatedDescription"
            })
          })]
        }), /*#__PURE__*/_jsxs(UIBox, {
          basis: columnWidth,
          children: [/*#__PURE__*/_jsx(Icon, {
            name: "deals"
          }), /*#__PURE__*/_jsx(H4, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.whyGetCertifiedSection.getRecognized"
            })
          }), /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.whyGetCertifiedSection.getRecognizedDescription"
            })
          })]
        })]
      })]
    })
  });
};
export default WhyGetCertifiedSection;